module.exports = __webpack_public_path__ + "static/media/img46.cbd57464.jpg";